import type { UseAudienceInfiniteQueryArgs } from "./useAudienceInfiniteQuery";
import { useAudienceInfiniteQuery } from "./useAudienceInfiniteQuery";

const pendingRequestsFilter = {
  id: "connections-pending-recipient",
  key: "connections",
  status: "pending",
  role: "recipient",
};

export const usePendingConnections = (args?: UseAudienceInfiniteQueryArgs) =>
  useAudienceInfiniteQuery({
    filters: [pendingRequestsFilter, ...(args?.filters ?? [])],
    ...args,
  });
